import React, { useEffect, useState } from "react";
import api from "../../../../api";
import "./WorkspaceLogs.css";
import DiffModal from "./DiffModal"; 
import {  Message } from "semantic-ui-react";
const WorkspaceLogs = ({ workspaceId ,onRevertSuccess }) => {
  const [logs, setLogs] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
const [showDiff, setShowDiff] = useState(false);
const [selectedChanges, setSelectedChanges] = useState([]);
const [successMessage, setSuccessMessage] = useState("");

const handleViewLogs = (entry) => {
  setSelectedChanges(entry.changes);
  setShowDiff(true);
};
const handleRevertSection = async (id) => {
  try {
    await api.botbuilder.revertChanges({ log_id: id });

    setShowDiff(false);

    const params = { workspace_id: workspaceId };
    const esc = encodeURIComponent;
    const query = Object.keys(params)
      .map((k) => esc(k) + "=" + esc(params[k]))
      .join("&");
    const response = await api.botbuilder.fetchWorkspaceLogs(query);
    if (response.status) {
      setLogs(response.data); 
    }
    if (onRevertSuccess) onRevertSuccess();

    setSuccessMessage("Reverted successfully!");
    setTimeout(() => setSuccessMessage(""), 3000);
  } catch (err) {
    console.error("Error reverting section:", err);
    setError("Failed to revert changes.");
    setTimeout(() => setError(""), 3000);
  }
};

  useEffect(() => {
    if (!workspaceId) return;
    const fetchLogs = async () => {
      setLoading(true);
      const params = {
        workspace_id: workspaceId
      };
      const esc = encodeURIComponent;
      const query = Object.keys(params)
        .map((k) => esc(k) + "=" + esc(params[k]))
        .join("&");
      try {
        const response = await api.botbuilder.fetchWorkspaceLogs(query);
        if (response.status) {
          setLogs(response.data);
          setError("");
        } else {
          setError(response.error || "Failed to load logs.");
        }
      } catch (err) {
        setError("Something went wrong.");
      }
      setLoading(false);
    };

    fetchLogs();
  }, [workspaceId]);
  const parseToLocalTime = (datetimeStr) => {
    // Convert "YYYY-MM-DD HH:mm:ss" to "YYYY-MM-DDTHH:mm:ssZ"
    const utcDateStr = datetimeStr.replace(" ", "T") + "Z";
    const localDate = new Date(utcDateStr);
  
    return localDate.toLocaleTimeString([], {
      hour: '2-digit',
      minute: '2-digit',
      hour12: true,
    });
  };
  
  const parseToLocalDate = (datetimeStr) => {
    const utcDateStr = datetimeStr.replace(" ", "T") + "Z";
    const localDate = new Date(utcDateStr);
  
    return localDate.toLocaleDateString(undefined, {
      weekday: "long",
      year: "numeric",
      month: "short",
      day: "numeric"
    });
  };
  

  if (loading) return <div className="ui loading form"></div>;
  if (error) return <Message color={"red"}>{error}</Message>;

  return (
    <div className="main">
        {showDiff && selectedChanges && (
 <DiffModal
  show={showDiff}
  onCancel={() => setShowDiff(false)}
  changes={selectedChanges}
  onRevertSection={handleRevertSection}
/>
)}
  {successMessage && (
              <Message color={"green"}>{successMessage}</Message>
            )}
    {Object.entries(logs).map(([date, entries]) => (
  <div key={date} className="date-format">
    <p className="text-uppercase">{parseToLocalDate(entries[0].created_at)}</p>
    {entries.map((entry, index) => (
      <div key={index} className="current-editor">
        <div className="now">{parseToLocalTime(entry.created_at)}</div>
        <div className="dots-line"></div>
        <div className="text-elipse note-content">{entry.note}</div>
        <div
          className="text-elipse name-title"
          style={{ fontSize: "15px", color: "#6F6969", fontWeight: "600" }}
        >
          {entry.user_name}
        </div>
       <div className="right-buttons">
  {entry.changes && entry.changes.length > 0 ? (
    <>
      <div
        className="text-elipse buttons-right"
        style={{ fontSize: "15px", color: "#6F6969", fontWeight: "600" }}
      >
        <button
          type="button"
          className="btn linear-gradient yr-submitbtn"
          onClick={() => handleViewLogs(entry)}
        >
          View Logs
        </button>
      </div>
      <div
        className="text-elipse buttons-right"
        style={{ fontSize: "15px", color: "#6F6969", fontWeight: "600" }}
      >
        <button
          type="button"
          className="btn linear-gradient yr-submitbtn"
          disabled={entry.reverted}
          onClick={() => handleRevertSection(entry.id)}
        >
          {entry.reverted ? "Reverted" : "Revert"}
        </button>
      </div>
    </>
  ) : (
    <span style={{ lineHeight: "38px", fontWeight: "600", color: "#6F6969" }}>
      No Changes
    </span>
  )}
</div>
      </div> 
    ))}
  </div>
))}

    </div>
  );
};

export default WorkspaceLogs;
